import axios from './interceptor';

const URL = `${process.env.REACT_APP_BASE_URL}/destination-itinerary-store`;

export async function createItineraryNote(payload) {
    const response = await axios.post(`${URL}/create`, payload);
    return response.data;
}

export async function getAllItineraryNotes(params = {}) {
    const response = await axios.get(`${URL}/get-all`, { params });
    return response.data;
}

export async function updateItineraryNote(id, payload) {
    const response = await axios.put(`${URL}/update/${id}`, payload);
    return response.data;
}

export async function deleteItineraryNote(id) {
    const response = await axios.delete(`${URL}/delete/${id}`);
    return response.data;
}
